# --------------------------------------------------*|
#   Common.Directives.PerfectScrollbar
# --------------------------------------------------*|
'use strict'
angular.module("siter.io").directive "perfectScrollbar", ["$parse", "$window", ($parse, $window) ->
  restrict: 'EA'
  transclude: true
  template: '<div><div ng-transclude></div></div>'
  replace: true
  link: ($scope, $elem, $attr) ->
    psOptions = [
      'wheelSpeed'
      'wheelPropagation'
      'minScrollbarLength'
      'useBothWheelAxes'
      'useKeyboard'
      'suppressScrollX'
      'suppressScrollY'
      'scrollXMarginOffset'
      'scrollYMarginOffset'
      'includePadding'
    ]
    jqWindow = angular.element($window)
    options = {}

    _onscroll = (e) ->
      scrollLoadDistance = parseInt $attr.scrollLoadDistance
      if $elem.scrollTop() is 0
        return
      else if $elem.scrollTop() > ($elem.prop('scrollHeight') - $elem.height()-scrollLoadDistance)
        !JSON.parse($attr.scrollDisabled) && $scope.$apply $attr.whenScrollDown

    $elem.unbind "scroll", _onscroll
    $elem.scroll _onscroll

    update = ->
      $scope.$evalAsync ->
        $elem.perfectScrollbar 'update'
        return
      if !$scope.$$phase
        $scope.$apply()
      return

    i = 0
    l = psOptions.length
    while i < l
      opt = psOptions[i]
      if $attr[opt] != undefined
        options[opt] = $parse($attr[opt])()
      i++
    $scope.$evalAsync ->
      $elem.perfectScrollbar options
      return
    $elem.bind 'mouseenter', update
    if $attr.refreshOnChange
      $scope.$watchCollection $attr.refreshOnChange, ->
        update()
        return
    if $attr.refreshOnResize
      jqWindow.on 'resize', update
    $elem.bind '$destroy', ->
      jqWindow.off 'resize', update
      $elem.perfectScrollbar 'destroy'
      return
    return
]



// WEBPACK FOOTER //
// ./src/app/common/directives/perfect-scrollbar.coffee